// Google Tag Manager utility
export function gtmEvent(event, data = {}) {
  if (window && window.dataLayer) {
    window.dataLayer.push({
      event,
      ...data
    });
  }
}
